import {useMessage} from '@coolcolduk/ui-mui';
import {Delete} from '@mui/icons-material';
import {Avatar, Box, Button, Card, CardContent, Grid, IconButton, Stack, Typography} from '@mui/material';
import HelpButtonWrapper from '../../../components/helpButton/HelpButtonWrapper';
import {useDeleteAccountToken} from '../../../hook/useDeleteAccountToken';
import useGetAllAccountToken, {HookAccountToken} from '../../../hook/useGetAllAccountToken';
import {firebaseAuth} from '../../../setup/firebase';
import {linkEtsyAccount} from '../../../util/etsy/linkEtsyAccount';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';

export default function EtsyAccounts() {
  const {accounts, refetchAccounts} = useGetAllAccountToken();
  const deleteAccount = useDeleteAccountToken();
  const {showMessage} = useMessage();
  const handleDeleteAccount = (account: HookAccountToken) =>
    deleteAccount(account.id)
      .then(() => {
        showMessage('Account deleted successfully', undefined, 'success');
        refetchAccounts();
      })
      .catch((e) => {
        console.error(e.message);
        showMessage('Failed to delete account', undefined, 'error');
      });

  if (!accounts) {
    return <Typography>Loading accounts...</Typography>;
  }

  return (
    <Stack spacing={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">Etsy Accounts</Typography>
        <HelpButtonWrapper helpTutorialEnum={HelpTutorialEnum.ETSY_LINK_ACCOUNT}>
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              const token = await firebaseAuth.currentUser?.getIdToken();
              if (!token) {
                showMessage('Token error, please try to refresh the page or login again');
                return;
              }
              linkEtsyAccount(token, () => refetchAccounts());
            }}
          >
            Add Account
          </Button>
        </HelpButtonWrapper>
      </Box>

      <Grid container spacing={2}>
        {accounts.map((account) => (
          <Grid size={{xs: 12, sm: 6, md: 4}} key={account.id}>
            <Card>
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar src={account.photoURL || undefined} alt={account.name} />
                  <Box sx={{flexGrow: 1}}>
                    <Typography variant="h6">{account.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Shop ID: {account.shopId}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      User ID: {account.userId}
                    </Typography>
                  </Box>
                  <IconButton onClick={() => handleDeleteAccount(account)} color="error" title="Delete account">
                    <Delete />
                  </IconButton>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
